import React, { useState } from 'react';
import { openWorkshopFlyerTab } from '../../constants/workshopFlyer';
import { WORKSHOP_2026_PATH } from '../../services/workshop2026Service';
import { useLocale } from '../../context/LocaleContext';
import styles from '../../styles/workshop2026Page.module.css';

const WorkshopShareInviteBlock: React.FC = () => {
  const { t } = useLocale();
  const [copied, setCopied] = useState(false);
  const pageUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}${WORKSHOP_2026_PATH}`
      : `https://recoverycommons.com${WORKSHOP_2026_PATH}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className={styles.shareInviteBlock}>
      <p className={styles.helperText}>{t('workshop.2026.share.lead')}</p>
      <div className={styles.shareInviteActions}>
        <button type="button" className={styles.shareInviteBtn} onClick={handleCopy}>
          {copied ? t('workshop.2026.share.copied') : t('workshop.2026.share.copy')}
        </button>
        <button type="button" className={styles.shareInviteBtn} onClick={openWorkshopFlyerTab}>
          {t('workshop.2026.share.flyer')}
        </button>
      </div>
    </div>
  );
};

export default WorkshopShareInviteBlock;
